export default "__VITE_ASSET__BUEaiw9T__"